import { render, staticRenderFns } from "./List-shipment-CDC.vue?vue&type=template&id=5a8719eb&scoped=true"
import script from "./List-shipment-CDC.vue?vue&type=script&lang=js"
export * from "./List-shipment-CDC.vue?vue&type=script&lang=js"
import style0 from "./List-shipment-CDC.vue?vue&type=style&index=0&id=5a8719eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8719eb",
  null
  
)

export default component.exports